import React from 'react';
import '../OfficesPage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';


const EmployeesQueueTableNoResults = () => (
    <div className="columns light-grey">
        <div className='column is-12 has-text-centered'>
            <HrbTranslate className='p1 pb-4' text='OfficesPage.Labels.None' />
        </div>
    </div>
);

export default EmployeesQueueTableNoResults